// src/pages/Home.jsx
import HeroSection from '../components/HeroSection';
import PartnersCarousel from '../components/PartnersCarousel';
import AboutSection from '../components/AboutSection';
import StatsSection from '../components/StatsSection';
import CoreServicesSection from '../components/CoreServicesSection';
import DigitalProductsSection from '../components/DigitalProductsSection';
import ContentSection from '../components/ContentSection';
import ContactSection from '../components/ContactSection';
import Images from '../Images';
import { i } from 'framer-motion/client';

const Home = () => {
  const contentSections = [
    {
      eyebrow: "JOB ALERT",
      heading: "Job Alert",
      description: "Stay ahead in your career with our Job Alert service. Get notified instantly about new job openings that match your skills and interests. Whether you're actively seeking new opportunities or just keeping your options open, we've got you covered with timely updates delivered straight to your phone.",
      imagePosition: "left",
      bgColor: "bg-brand-cream",
      imageUrl: Images.job,
      buttonText: "Subscribe Now",
      link:"https://api.quicksmscontent.com/"
    },
    {
      eyebrow: "HEALTH TIPS",
      heading: "Health Tips",
      description: "Your health matters, and staying informed is the first step to wellness. Subscribe to our Health Tips service for daily advice, reminders, and expert insights on nutrition, fitness, mental health, and more. Live your best life with trusted information at your fingertips.",
      imagePosition: "right",
      bgColor: "bg-white",
      imageUrl: Images.health,
      buttonText: "Get Tips",
       link:"https://api.quicksmscontent.com/"
    },
    {
      eyebrow: "SPORTS NEWS",
      heading: "Sports News",
      description: "Never miss a moment of the action! Get real-time updates on your favorite sports, teams, and players. From football to basketball, cricket to athletics, our Sports News service keeps you in the loop with scores, highlights, and breaking news delivered instantly.",
      imagePosition: "left",
      bgColor: "bg-brand-cream",
      imageUrl: Images.sports,
      buttonText: "Follow Now",
       link:"https://api.quicksmscontent.com/"
    },
    {
      eyebrow: "QUICK RENT",
      heading: "Quick Rent",
      description: "Finding a rental property just got easier. Our Quick Rent service connects you with verified listings in your desired location. Browse apartments, houses, and commercial spaces with detailed descriptions, photos, and pricing. Your perfect rental is just a message away.",
      imagePosition: "right",
      bgColor: "bg-white",
      imageUrl: Images.rent,
      buttonText: "Find Now",
       link:"https://quickrentgh.com/"
    },
    {
      eyebrow: "QUICK DISCOUNT",
      heading: "Quick Discount",
      description: "Save more on the things you love! With Quick Discount, get exclusive deals and offers from top brands and retailers. From fashion to electronics, groceries to entertainment, enjoy instant savings delivered directly to your phone. Smart shopping starts here.",
      imagePosition: "left",
      bgColor: "bg-brand-cream",
      imageUrl: Images.discount,
      buttonText: "View Deals",
       link:"https://quickdiscountgh.com/",
    }
  ];

  return (
    <main>
      <HeroSection />
      <PartnersCarousel />
      <AboutSection />
      <StatsSection />
      <CoreServicesSection />
      <DigitalProductsSection />
      {contentSections.map((section, index) => (
        <ContentSection key={index} {...section} index={index} />
      ))}
      <ContactSection />
    </main>
  );
};

export default Home;